import { UIComponent, html } from "canvas-ui";
import { DamageNumberGameObject } from "./damageNumber.gameObject";

interface DamageNumberProps {
  value: number;
  fontSize: number;
  gameObject: DamageNumberGameObject;
}

export const DamageNumber: UIComponent = (
  hooks,
  { value, gameObject }: DamageNumberProps
) => {
  const [opacity, setOpacity] = hooks.useState(1);
  const [fontSize, setFontSize] = hooks.useState(gameObject.getFontSize());

  hooks.useEffect(() => {
    const onFontSizeChange = (e: number) => {
      setFontSize(e);
    };
    const onOpacityChange = (e: number) => {
      setOpacity(e);
    };

    gameObject.addListener("onFontSizeChange", onFontSizeChange);
    gameObject.addListener("onOpacityChange", onOpacityChange);
    return () => {
      gameObject.removeListener("onOpacityChange", onOpacityChange);
      gameObject.removeListener("onFontSizeChange", onFontSizeChange);
    };
  }, []);

  return html`<view
    width="100%"
    textAlign="center"
    font=${`bold ${fontSize}px arial`}
    color=${`rgba(255, 255, 255, ${opacity})`}
    >${String(value)}</view
  >`;
};
